import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { P, fs, radius, eyebrow, pillSt, tint, tintB, tintT } from '../theme/tokens';

const Box = styled.section`
  border: 1px solid ${tintB(P.info)};
  background: ${tint(P.info)};
  border-radius: ${radius.lg}px;
  padding: 12px 14px;
`;

const Head = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 9px;
  color: ${tintT(P.info)};

  svg {
    font-size: 11px;
  }
  h3 {
    ${eyebrow}
    margin: 0;
    color: ${tintT(P.info)};
  }
`;

const Note = styled.span`
  margin-left: auto;
  font-size: 11px;
  color: ${P.subtle};
`;

const Text = styled.div`
  background: ${P.white};
  border: 1px solid ${P.border};
  border-radius: ${radius.md}px;
  padding: 11px 13px;
  font-size: ${fs.sm}px;
  line-height: 1.5;
  color: ${P.ink};
  white-space: pre-wrap;
`;

const Loading = styled(Text)`
  color: ${P.subtle};
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
`;

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 14px;
  border-radius: ${radius.md}px;
  font-family: inherit;
  font-size: ${fs.xs}px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$primary ? 'transparent' : P.border)};
  background: ${(p) => (p.$primary ? P.grad : P.white)};
  color: ${(p) => (p.$primary ? P.white : P.muted)};

  &:hover:not(:disabled) {
    border-color: ${(p) => (p.$primary ? 'transparent' : P.navy)};
    color: ${(p) => (p.$primary ? P.white : P.navyInk)};
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  svg {
    font-size: 10px;
  }
`;

const visibleBasis = (basis) => basis && !['general', 'disabled'].includes(basis);

export default function SuggestionCard({ suggestion, basis, loading, sending, onUse, onEdit, onDismiss }) {
  return (
    <Box aria-label="AI suggestion" aria-busy={loading}>
      <Head>
        <FontAwesomeIcon icon={faBolt} />
        <h3>AI suggestion</h3>
        {!loading && visibleBasis(basis) && <span style={pillSt(P.info, { fontSize: 11, padding: '1px 8px' })}>{basis}</span>}
        <Note>You approve before it sends</Note>
      </Head>
      {loading ? (
        <Loading>Drafting a reply…</Loading>
      ) : (
        <>
          <Text>{suggestion}</Text>
          <Actions>
            <Btn type="button" onClick={onDismiss}>
              Dismiss
            </Btn>
            <Btn type="button" onClick={onEdit}>
              Edit
            </Btn>
            <Btn type="button" $primary onClick={onUse} disabled={sending}>
              <FontAwesomeIcon icon={faPaperPlane} />
              Use
            </Btn>
          </Actions>
        </>
      )}
    </Box>
  );
}
